import { useApiMutation } from "./use-api-mutation";

export function useTranslateReturnReason() {
  return useApiMutation(
    "post",
    "/shops/{shopId}/reasons/translate",
    {
      notify: { success: false },
      meta: {
        error: {
          title: "Translation Error",
        },
      },
      mapVariables: ({
        shopId,
        text,
        sourceLocale,
        targetLocales,
      }: {
        shopId: string;
        text: string;
        sourceLocale: string;
        targetLocales: string[];
      }) => ({
        params: { path: { shopId } },
        body: {
          text,
          sourceLocale,
          targetLocales,
        },
      }),
    },
  );
}
